export default "__VITE_ASSET__27175936__"